import React, { useMemo } from 'react';
import { faDownload, Icon, CustomColumns, CustomTable } from '@/ui/components';
import { StyledLinkContainer } from '@/ui/globalStyles';
import { timeConverter } from '@/utils/helpers';
import { useShippingPlan } from '@/api/ShippingPlan';
import { ShippingPlan } from '@/types';

export const ShippingPlanDataGrid = () => {
  const { data, isFetching } = useShippingPlan();

  const columns: CustomColumns<ShippingPlan> = useMemo(
    () => [
      {
        dataIndex: 'customerName',
        title: 'Customer',
        width: 200,
      },
      { dataIndex: 'fileName', title: 'File Name' },
      {
        dataIndex: 'createdDate',
        title: 'Created Date',
        width: 180,
        render: (value) => timeConverter(value),
      },
      {
        dataIndex: 'fileUrl',
        title: 'File URL',
        width: 100,
        align: 'center',
        render: (value, item) => (
          <StyledLinkContainer>
            <a href={value} download={item.fileName} aria-label="Download">
              <Icon icon={faDownload} />
            </a>
          </StyledLinkContainer>
        ),
      },
    ],
    [],
  );

  return (
    <CustomTable
      dataSource={data?.entities || []}
      columns={columns}
      rowKey="documentId"
      loading={isFetching}
    />
  );
};
